import { render, staticRenderFns } from "./NetworkNotification.vue?vue&type=template&id=836d06c8&scoped=true&"
import script from "./NetworkNotification.vue?vue&type=script&lang=js&"
export * from "./NetworkNotification.vue?vue&type=script&lang=js&"
import style0 from "./NetworkNotification.vue?vue&type=style&index=0&id=836d06c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836d06c8",
  null
  
)

export default component.exports